export enum PanelModes {
    Hidden = "hidden",
    Maximized = "maximized",
    MaximizedLocked = "maximized-locked",
    Minimized = "minimized",
    Regular = "regular",
    MaximizedTransitioning = "maximized-transitioning",
    MinimizedTransitioning = "minimized-transitioning",
}

export enum PanelNames {
    Bottom = "bottom",
    Controls = "controls",
    Left = "left",
    LeftBottom = "leftBottom",
    LeftTop = "leftTop",
    Notifications = "notifications",
    Overlay = "overlay",
    Perimeter = "perimeter",
    RightBottom = "rightBottom",
    RightTop = "rightTop",
    Top = "top",
    Wallpaper = "wallpaper",
    Wallboard = "wallboard",
    Snapshot = "snapshot",
}
